var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-task-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-32488ea4!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-task-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeTaskDetail.vue
// module id = 687
// module chunks = 1